'use strict';

var processInclude = require('base/util');
$(document).ready(function() {
    processInclude(require('./product/wishlist'));
    processInclude(require('./components/plpAddToCart'));
});

$('body').on('product:updateAvailability', function(e, data) {
    var className = data.product.availability.classType;
    var errMessage = data.product.availability.messages[0];
    var ele = $(e.target).find('.product-description');
    if (className === 'qty-err') {
        ele.find('.add-to-cart').prop('disabled', true);
    } else {
        ele.find('.add-to-cart').prop('disabled', false);
    }

    var colorName = $(ele)
        .find('.color-value.selected')
        .data('attrValue');
    if (typeof colorName !== 'undefined') {
        $(ele)
            .find('.selected-color')
            .text(colorName.toLowerCase());
    }
    $(ele)
        .find('.product-availability')
        .html('<div class="col-12 message ' + className + '">' + errMessage + '</div>');

    var preOrderLabel = $('.add-to-cart-btn-labels').attr('data-value-preorder-text');
    var addToCartLabel = $('.add-to-cart-btn-labels').attr('data-value-cart-text');
    var hasPreorder = data.product.availability.messages[0].indexOf('pre-order-ship-msg') >= 0;

    if (hasPreorder) {
        $(ele)
            .find('.add-to-cart span')
            .text(preOrderLabel);
        $(ele)
            .find('.availability')
            .hide();
        $(ele)
            .find('.availability-container .availability-msg')
            .show();
    } else {
        $(ele)
            .find('.add-to-cart span')
            .text(addToCartLabel);
        $(ele)
            .find('.availability')
            .show();
        $(ele)
            .find('.availability-container .availability-msg')
            .hide();
    }
    $(ele)
        .find('.product-desc .content')
        .html(data.product.shortDescription);
    $(ele)
        .find('.description-and-detail')
        .empty()
        .html(data.product.descriptionAndDetailsHtml);
    $(ele)
        .find('.sales-bdg')
        .empty()
        .html(data.product.saleBadgingHtml);
    $(ele)
        .find('.ex-promotion')
        .empty()
        .html(data.product.exclusiveBadgingHtml);
    $(ele)
        .find('.product-name')
        .empty()
        .html(data.product.productName);
});
